import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState={
    data:{}
}

const miscDataSlice=createSlice({
    name:"miscData",
    initialState,
    reducers:{
        setMiscData:(state,action)=>{
            state.data=action.payload
        }
    }
})

export const {setMiscData}=miscDataSlice.actions

export const getMiscDataThunk=(successData)=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/admins/misc","get")
            if(!res.err){
                successData(res?.data)
                dispatch(setMiscData(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load content", severity: "error" }))
            }
        }catch(err){
            dispatch(setToast({ show: true, message: "Failed to load content", severity: "error" }))
        }
    }
}
export default miscDataSlice.reducer